import { useTreeStateContext } from "../../contexts/TreeContext";
import cellSizeEditor from "../../data/cellSizeEditor";

function useBlockFilter() {
    const { blocks } = useTreeStateContext();

    const defaultOffset = { x : 0, y : 67 };

    const filterBlocksVisible = (position) => {


        const x = (position.x / position.scale) + defaultOffset.x;
        const y = (position.y / position.scale) + defaultOffset.y;

        const area = {x : -x , y : -y, w : window.innerWidth / position.scale, h : window.innerHeight / position.scale};
        return filterBlock(area)
    }

    const filterBlocksSelected = (position, zone, x, y, w, h) => {

        x = Math.min(x, zone.x)
        y = Math.min(y, zone.y)
        
        x = ( (- position.x + x - 60) / position.scale)
        y = ( (- position.y + y - defaultOffset.y) / position.scale)
        w = (w / position.scale);
        h = (h / position.scale);

        const area = {x : x , y : y, w : w , h : h };
        return filterBlock(area)
    }

    const findMinAndMaxBlocksCoord = (blocks) => {

        let x_min = null;
    
        let y_min = null;
    
        let x_max = null;
    
        let y_max = null;
    
        for (let i in blocks) {
            let block = blocks[i];
            if (!x_min || block.x < x_min) x_min = block.x;
                    
            if (!y_min || block.y < y_min) y_min = block.y;
    
            if (!x_max ||block.x + block.width * cellSizeEditor > x_max )  x_max = block.x + block.width * cellSizeEditor;
    
            if (!y_max ||block.y + block.height * cellSizeEditor > y_max) y_max = block.y + block.height * cellSizeEditor;        
        }
    
        return { min : { x : x_min, y : y_min}, max : { x : x_max, y : y_max}}
    }

    const filterBlock = (area) => {
        const blocks_filter = [];
        const childLength = cellSizeEditor;
        for(var i = 0; i < blocks.length; i++) {
            let block = blocks[i];
            
            let length = 0;
            if(block.children) {
                length = block.children.length > 0 ? block.children.length - 1 : block.children.length;
            }
    
            const block_info = {x : block.x, y : block.y , w : (block.width * cellSizeEditor) , h : (block.height * cellSizeEditor) + (length * childLength) }
            
            if (
                area.x < block_info.x + block_info.w &&
                area.x + area.w > block_info.x &&
                area.y < block_info.y + block_info.h &&
                area.h + area.y > block_info.y
              ) {
                blocks_filter.push(block);
              }
    
        }
        return blocks_filter;
    }
    
    return { filterBlocksVisible, filterBlocksSelected, findMinAndMaxBlocksCoord, blocks }
}

export default useBlockFilter;